<!-- src/components/Layout.vue -->
<template>
	<div class="flex flex-col h-screen overflow-hidden bg-gray-50">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">


		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<el-header
			style="background-color: #545c64; display: flex; align-items: center; padding: 0 40px; justify-content: space-between;">
			<h1 style="color: #ffffff; font-family: 'Arial', sans-serif; font-size: 24px; margin: 0;">
				<!-- QIUI 开发者平台 -->
				{{ $t('language000166') }}
			</h1>

			<div style="display: flex; align-items: center;">
				<el-dropdown @command="handleCommand">
					<div style="display: flex; align-items: center;">
						<!-- 左侧图标 -->
						<img :src="avatar" alt="Logo" style="height: 40px; margin-left: 20px;">

						<!-- 昵称 -->
						<span style="color: #ffffff; margin-left: 10px;">{{ nickName }}</span>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="a" v-show="false">
							<!-- 企业开发者账号认证 -->
							{{ $t('language000167') }}
						</el-dropdown-item>
						<el-dropdown-item command="b" v-show="false">
							<!-- 个人开发者账号认证 -->
							{{ $t('language000168') }}
						</el-dropdown-item>
						<el-dropdown-item command="c" v-show="false">
							<!-- 修改密码 -->
							{{ $t('language000169') }}
						</el-dropdown-item>
						<el-dropdown-item divided command="d">
							<!-- 退出账号 -->
							{{ $t('language000170') }}
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

			</div>
		</el-header>

		<el-container style="background-color:#545c64; flex: 1; overflow: hidden;">
			<!-- 下面 -->
			<el-aside style="width: auto;">
				<!-- 下面的左边 -->
				<el-menu default-active="/FirstPage" @select="handleSelect" class="el-menu-vertical-demo"
					background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">

					<el-menu-item index="/FirstPage">
						<i class="el-icon-s-custom"></i>
						<span slot="title">
							<!-- 首页 -->
							{{ $t('language000171') }}
						</span>
					</el-menu-item>

					<el-menu-item index="/DevicesHome">
						<i class="el-icon-setting"></i>
						<span slot="title">
							<!-- 已激活设备 -->
							{{ $t('language000172') }}
						</span>
					</el-menu-item>

					<el-menu-item index="/ApiCallLogging">
						<i class="el-icon-document-copy"></i>
						<span slot="title">
							<!-- API调用记录 -->
							{{ $t('language000308') }}
						</span>
					</el-menu-item>

					<el-menu-item index="/Config4g">
						<i class="el-icon-cpu"></i>
						<span slot="title">
							<!-- 4G配置 -->
							{{ $t('language000359') }}
						</span>
					</el-menu-item>

					<el-menu-item index="/Equipment">
						<i class="el-icon-document"></i>
						<span slot="title">
							<!-- 开发文档 -->
							{{ $t('language000173') }}
						</span>
					</el-menu-item>

				</el-menu>

			</el-aside>



			<el-main
				style="background-color: #ffffff; overflow-y: auto; padding: 0; border: 0; display: flex; flex-direction: column;">
				<!-- 下面的右边 -->
				<router-view style="flex: 1; display: flex; flex-direction: column;"></router-view>
			</el-main>

		</el-container>

		<!-- 联系我们 -->
		<div class="fixed bottom-8 right-8 z-50">
			<!-- 展开状态的联系框 -->
			<div v-if="isExpanded" style="background-color: white;"
				class="contact-panel bg-white/95 rounded-xl shadow-xl p-6 w-182 transition-all duration-300">
				<div class="flex justify-between items-center mb-4">
					<h3 class="text-lg font-medium text-gray-800">
						<!-- 联系我们 -->
						{{ $t('language000174') }}
					</h3>
					<button @click="togglePanel"
						class="text-gray-500 hover:text-gray-700 transition-colors !rounded-button">
						<i class="fas fa-minus"></i>
					</button>
				</div>

				<!-- 联系方式列表 -->
				<div class="space-y-4">
					<!-- 电话 -->
					<div class="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-all">
						<div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center">
							<i class="fas fa-phone text-blue-500"></i>
						</div>
						<div>
							<div class="text-sm text-gray-500">Telegram</div>
							<p class="text-gray-800 font-medium">https://t.me/+avTMFlZv9T4xNTBl</p>
						</div>
					</div>

					<!-- 邮箱 -->
					<a href="mailto:contact@company.com" class="contact-item group">
						<div class="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-all">
							<div class="w-10 h-10 bg-purple-50 rounded-full flex items-center justify-center">
								<i class="fas fa-envelope text-purple-500"></i>
							</div>
							<div>
								<div class="text-sm text-gray-500">Mail</div>
								<div class="text-gray-800 font-medium">service@qiuitoy.com</div>
							</div>
						</div>
					</a>

					<!-- 社交媒体 -->
					<div class="border-t pt-4">
						<div class="text-sm text-gray-500 mb-3">
							<!-- 关注我们 -->
							{{ $t('language000175') }}
						</div>
						<div class="flex space-x-4">
							<button v-for="(social, index) in socials" :key="index"
								class="social-btn group relative !rounded-button" @mouseenter="showTooltip(index)"
								@mouseleave="hideTooltip">
								<div
									class="w-10 h-10 bg-gray-50 rounded-full flex items-center justify-center hover:bg-gray-100 transition-all">
									<i :class="social.icon" class="text-gray-600"></i>
								</div>
								<!-- 工具提示 -->
								<div v-show="activeTooltip === index"
									class="absolute -top-10 left-1/2 transform -translate-x-1/2 px-3 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap">
									{{ social.name }}
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- 收起状态的浮动按钮 -->
			<button v-else @click="togglePanel"
				class="w-14 h-14 bg-blue-500 rounded-full shadow-lg flex items-center justify-center hover:bg-blue-600 transition-colors !rounded-button">
				<i class="fas fa-headset text-white text-xl"></i>
			</button>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../src/utils/StringUtil.js';

	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {
			//默认打开的路由
			if (this.$route.path !== '/FirstPage') {
				this.$router.push({
					path: '/FirstPage',
					query: {}
				});
			}
			
			this.getUserInfo()
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				isfirst: 0, //是否是第一次加载
				password: '',
				isExpanded: false,
				activeTooltip: -1,
				socials: [{
					name: '微信',
					icon: 'fab fa-weixin'
				}, {
					name: '微博',
					icon: 'fab fa-weibo'
				}, {
					name: 'LinkedIn',
					icon: 'fab fa-linkedin'
				}, {
					name: '抖音',
					icon: 'fab fa-tiktok'
				}],
				avatar: '', //头像
				nickName: '', //昵称
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				if (this.$route.path !== key) { //同一个地址 不重复导航
					this.$router.push(key);
				}
			},
			handleCommand(command) { //菜单的点击
				switch (command) {
					case "a": //企业开发者认证
						let pageA = this.$router.resolve({
							path: '/EnterpriseRealName',
							query: {}
						});
						window.open(pageA.href, '_blank');
						break
					case "b": //个人开发者认证
						let pageB = this.$router.resolve({
							path: '/PersonalRealName',
							query: {}
						});
						window.open(pageB.href, '_blank');
						break
					case "c": //修改密码
						console.log("修改密码");
						break
					case "d": //处理退出账号的逻辑
						this.loadingData = true;
						axios.post(this.$p_url_Developers + '/platform/info/platformLogout', {}, {
								withCredentials: true, // 允许跨域携带 cookie
								headers: {
									'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
									'Accept': '*/*',
									'authorization': Cookies.get("tokenDevelopment"),
								}
							})
							.then(response => {
								this.loadingData = false;
								console.log("返回的值：", response.data)
								if (response.data.code === 200) { // 检查状态
									Cookies.remove("tokenDevelopment"); // 清空token
									this.$router.push({ //跳转到登录
										path: '/DevelopersLogin',
										query: {}
									});
								} else {
									alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
								}
							})
							.catch(error => {
								alert("请求失败：" + error);
							});
						break
				}
			},
			getUserInfo() { //获取用户信息
				this.loadingData = false;
				axios.get(this.$p_url_Developers + '/platform/info/getSysUserInfo', {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'authorization': Cookies.get("tokenDevelopment"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("获取用户信息 数据返回：", response.data)
						if (response.data.code === 401) { //登录失效
							Cookies.remove("tokenDevelopment");
							this.$router.push({ //跳转到登录
								path: '/DevelopersLogin',
								query: {}
							});
						} else if (response.data.code === 200) { // 检查状态
							this.avatar = response.data.data.avatar; //头像
							this.nickName = response.data.data.nickName; //昵称
						} else {
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			togglePanel() {
				this.isExpanded = !this.isExpanded;
			},
			showTooltip(index) {
				this.activeTooltip = index;
			},
			hideTooltip() {
				this.activeTooltip = -1;
			},
			//...
		}
	};
</script>

<style>
	h1 {
		margin: 0;
		color: #ddd;
	}

	.contact-panel {
		animation: slideIn 0.3s ease-out;
	}

	@keyframes slideIn {
		from {
			transform: translateX(100%);
			opacity: 0;
		}

		to {
			transform: translateX(0);
			opacity: 1;
		}
	}

	.contact-item {
		display: block;
		text-decoration: none;
	}

	.social-btn:hover .tooltip {
		visibility: visible;
		opacity: 1;
	}
</style>